import React, { Component } from "react";
import { connect } from "react-redux";
import { AppBar, IconButton, Icon } from "@material-ui/core";
import MailIcon from "@material-ui/icons/Mail";

import { createProject } from "../../redux/store/actions/projectActions";
import CrearProyectoModal from "../atoms/proyectos/CrearProyectoModal";
import Modal from "react-responsive-modal";

class HeaderProjects extends Component {
  state = {
    open: false
  };

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
    return (
      <AppBar position="static">
        <div className="blue darken-4">
          <h6 style={{ float: "left", padding: "5px 10px" }}>Proyectos</h6>
          <div style={{ float: "right" }}>
            <IconButton color="inherit">
              <Icon onClick={this.onOpenModal}>add</Icon>
            </IconButton>
            <IconButton color="inherit">
              <MailIcon />
            </IconButton>
          </div>
          <Modal open={open} onClose={this.onCloseModal} center>
            <CrearProyectoModal onCloseModal={this.onCloseModal} />
          </Modal>
        </div>
      </AppBar>
    );
  }
}

const mapStateToProps = state => {
  // console.log(state);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createProject: project => dispatch(createProject(project))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderProjects);
